/** Load only requested print outlines, sharing concurrent requests per font. */
export function createFontLoader(options:{files:Readonly<Record<string,string>>;read:(file:string)=>Promise<ArrayBuffer>;register:(name:string,bytes:ArrayBuffer)=>void;ready?:(name:string)=>boolean}) {
  const pending=new Map<string,Promise<void>>();
  const loaded=new Set<string>();
  function ensure(name:string):Promise<void> {
    if(!Object.prototype.hasOwnProperty.call(options.files,name))return Promise.reject(new Error('Unknown print font.'));
    const file=options.files[name];
    if(!/^[A-Za-z0-9_.-]+\.(ttf|otf)$/i.test(file))return Promise.reject(new Error('Invalid print font file.'));
    if(loaded.has(name)||options.ready?.(name))return Promise.resolve();
    const existing=pending.get(name);if(existing)return existing;
    const request=Promise.resolve().then(()=>options.read(file)).then(bytes=>{
      if(!bytes.byteLength)throw new Error('The print font file is empty.');
      options.register(name,bytes);loaded.add(name);
    }).finally(()=>pending.delete(name));
    pending.set(name,request);return request;
  }
  return {ensure,ensureAll:(names:Iterable<string>)=>Promise.all(Array.from(new Set(names),ensure)).then(()=>undefined)};
}
